export const STRIPE_PUBLISHABLE_KEY = process.env
  .REACT_APP_STRIPE_PUSHLISHABLE_KEY as string;
export const STRIPE_SECRET_KEY = process.env
  .REACT_APP_STRIPE_SECRET_KEY as string;
